import { bootstrapApplication } from '@angular/platform-browser';
// Importing the compiler makes the JIT compiler available at runtime which
// allows NgModule-based lazy-loaded modules to be compiled when using
// `bootstrapApplication`. This is a development-time workaround; AOT is
// recommended for production.
import '@angular/compiler';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
